<template>
	<div id="carousel">
		
		<carousel-3d :display="3" :controls-visible="true" class="carousel-box" :perspective="0" :width="200" :height="400" :space="400" >
			<slide v-for="(data,key) in datas" :key="key" :index="key"  @click="showModal(key)" >
				<img :src="(data.active)?data.src:'./logo.png'" alt="">
				<h3>{{data.name}}</h3>
				<button type="button"  class="btn"  @click="showModal(key)">Découvrir</button>
			
			</slide>
<!--			<slide :index="1">-->
<!--				<img src="../assets/logo.png" alt="">-->
<!--				-->
<!--				<h3>Nom</h3>-->
<!--				<button type="button"  class="btn"  @click="showModal(1)">Découvrir</button>-->
<!--			-->
<!--			</slide>-->
<!--			<slide :index="2">-->
<!--				<img src="../assets/logo.png" alt="">-->
<!--				-->
<!--				<h3>Nom</h3>-->
<!--				<button type="button"  class="btn"  @click="showModal(2)">Découvrir</button>-->
<!--			-->
<!--			</slide>-->
<!--			<slide :index="3">-->
<!--				<img src="../assets/logo.png" alt="">-->
<!--				-->
<!--				<h3>Nom</h3>-->
<!--				<button type="button"  class="btn"  @click="showModal(3)">Découvrir</button>-->
<!--			-->
<!--			-->
<!--			</slide>-->
		
		</carousel-3d>
		
		<modal v-show="isModalVisible" @close="closeModal" :header-title='modalTitle' :body-text="modalBody" :famille="false"/>
	</div>


</template>

<script>
	
	// import axios from 'axios';
	import {Carousel3d, Slide} from 'vue-carousel-3d';
	import modal from '../components/modal.vue';
	
	export default {
		name: 'carousel',
		data() {
			return {
				customers: [],
				errors: [],
				isModalVisible :false,
				modalTitle:"",
				modalBody:[],
				datas:[
					{
						'name':'bob',
						'active':true,
					'src':'./logo.png'
				},
					{
						'name':'bob',
						'active':false,
						'src':'./logo.png'
					},
				]
			}
		},
		components: {
			Carousel3d,
			Slide,
			modal
		},
		// created() {
		// 	this.LoadAll()
		// },
		
		methods: {
			
			// LoadAll() {
			// 	axios.get(`http://localhost:3000/customers`)
			// 		.then(response => {
			// 			// JSON responses are automatically parsed.
			// 			this.customers = response.data
			// 		})
			// 		.catch(e => {
			// 			this.errors.push(e)
			// 		})
			// },
			showModal(key) {
				this.modalTitle = "Bienvenue "+key;
				for(let i=0;i<=key;i++){
					this.modalBody[i] = "link "+i;
					
				}
				this.isModalVisible = true;
			},
			closeModal() {
				this.isModalVisible = false;
				this.modalBody=[]
			}
			
		}
		
		
	}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" >
	
	
	div.carousel-3d-controls{
		color:white;
		a.next,a.prev{
			color:white;
		}
	}
	#carousel{
		display:flex;
		justify-content: center;
		.carousel-box{
			width: 70%;
			
			
		}
	}
	.modal-content {
		display: none;
	}
	
	.carousel-3d-slide {
		 display: grid;
		 text-align: center;
		 margin: auto;
		 background: none;
		 border: none;
		 padding: 20px;
		 h3{
			 color:white;
		 }
		 img {
			 width: 100%;
			 border-radius: 50%;
			 border: 1px solid grey;
			 background: white;
		 }
		
		 button {
			 border: 1px solid black;
			 cursor: pointer;
			 background: #9b9b9b;
			 color: white;
			 font-size:1em;
			 font-weight: bold;
			 display: table-cell;
			 vertical-align: bottom;
			 transition: .5s;
		 }
		
		 button:hover {
			 background: white;
			 color: black;
			
		 }
	 }

</style>
